import * as React from 'react';
import { Box, Thumbnail, Text } from '@wix/design-system';
import s from './ChooseChatFlow.scss';
import AIIcon from './ai-icon.svg';
export const ChooseChatFlow = _ref => {
  let {
    data: {
      chatFlowOptions
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const sendSelectedFlow = option => {
    send(option);
    onWidgetAction(PRICING_PLANS_CHOOSE_CHAT_FLOW, {
      action: 'select',
      value: option
    });
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 4,
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(AIIcon, null)), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    align: "center"
  }, "I can help you to set up your pricing plans. Type what kind of plans you want to create"), /*#__PURE__*/React.createElement(Box, {
    gap: 1,
    direction: "vertical"
  }, chatFlowOptions.map(option => {
    return /*#__PURE__*/React.createElement(Thumbnail, {
      className: s.buttonWrapper,
      onClick: () => sendSelectedFlow(option)
    }, /*#__PURE__*/React.createElement(Box, {
      padding: "SP2"
    }, /*#__PURE__*/React.createElement(Text, {
      skin: "primary",
      size: "small"
    }, option)));
  })));
};
export const PRICING_PLANS_CHOOSE_CHAT_FLOW = 'PRICING_PLANS_CHOOSE_CHAT_FLOW';
//# sourceMappingURL=ChooseChatFlow.js.map